import defaultAttributes from '../defaultAttributes';

const ArrowBigDown = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M9 3h6v11h4l-7 7-7-7h4z' }]],
];

export default ArrowBigDown;
